/**
 * @file CapAssertBreakpoint
 * @module Capitan/es6/CapAssertBreakpoint
 * @copyright Brandung GmbH & Co KG
 * @author Sebastian Steiner
 * @version 2.0
 * @license MIT License (MIT)
 * @date 21.01.2018
 *
 * @param {string} element - Element selector, e.g. 'body', '.foobar > p'
 * @param {string} pseudo - Pseudoelement, e.g. ':before', ':after'
 * @param {string} property - CSS property, e.g. 'content', 'font-size'
 * @returns {*} string - returns the property value
 */
const CapGetComputedStyle = (element, pseudo = null, property) => window.getComputedStyle(document.querySelector(element), pseudo).getPropertyValue(property).replace(/\\/g, '').replace(/(^("|')|("|')$)/g, '');

export default CapGetComputedStyle;